import { useEffect, useState } from "react";
import { Container, Loader, ActionIcon, Group, Text } from "@mantine/core";
import { IconPlus, IconPencil } from "@tabler/icons-react";
import HttpClient from "../helpers/HttpClient";
import { Tag } from "../types/tag.type";
import { useNavigate } from "react-router-dom";

function TagList() {
  const [loading, setLoading] = useState(true);
  const [tags, setTags] = useState<Tag[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const httpClient = new HttpClient<Tag>("/tag");
    const fetchTags = async () => {
      try {
        const result: Tag[] = await httpClient.getAll();
        setTags([...result].sort((a, b) => a.name.localeCompare(b.name)));
      } catch (error) {
        console.error("API call failed:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTags();
  }, []);

  return (
    <Container fluid pb={10} mt={10}>
      <Group gap={25} visibleFrom="xs" >
        <h1>Tags</h1>
        <ActionIcon variant="filled" size="xl" radius="xl" aria-label="Add Tag" onClick={() => navigate('/tag/create')}>
          <IconPlus style={{ width: '70%', height: '70%' }} stroke={1.5} />
        </ActionIcon>
      </Group>
      {loading ? (
        <Loader size="md" />
      ) : (
        <>
          {tags.map(tag => (
            <Group key={tag.id}>
              <Text c={tag.color}>{tag.name}{tag.color}</Text>
              <ActionIcon
                variant="light"
                color="blue"
                onClick={() => navigate(`/tag/edit/${tag.id}`)}
                aria-label="Edit"
              >
                <IconPencil size={18} />
              </ActionIcon>
            </Group>
          ))}
        </>
      )}
    </Container>
  );
}

export default TagList;
